import { z } from "zod";
import { IFilterModel, IGridPostModel } from "common/models/GridModels";
import { IDropdownModel } from "common/models/IDropdownModel";

export const MemberTypewiseSectionConfigSchema = z.object({
  memberTypewiseSectionConfigID: z.string().nullish(),
  memberTypeID: z
    .string({ required_error: "Select Member Type" })
    .min(1, "Select Member Type"),
  sectionID: z
    .string({ required_error: "Select Section" })
    .min(1, "Select Section"),
  isOvernightIssue: z.boolean(),
  overnightIssueMaxItems: z.coerce
    .number({
      invalid_type_error: "Enter Number",
    })
    .positive("Enter Over night Issue Max Items")
    .transform((value) => (value === 0 ? null : value)),
  isOnPremisesIssue: z.boolean(),
  onPremisesIssueEndTime: z.coerce.date().nullish(),
  remarks: z
    .string()
    .max(100, "Remarks must not be greater than 100 characters")
    .nullable(),
});

export type IMemberTypewiseSectionConfig = z.infer<
  typeof MemberTypewiseSectionConfigSchema
> & {
  memberType: IDropdownModel;
  library: IDropdownModel;
  section: IDropdownModel;
};

export interface MemberTypewiseSectionConfigFormProps {
  memberTypewiseSectionConfig?: IMemberTypewiseSectionConfig;
}

export interface IMemberTypewiseSectionConfigGridModel {
  memberTypewiseSectionConfigID: string | number;
  memberTypeName: string;
  sectionName: string;
  isOvernightIssue: boolean;
  overnightIssueMaxItems: number;
  isOnPremisesIssue: boolean;
  onPremisesIssueEndTime: Date;
  libraryName: string;
  remarks: string;
}

export interface IMemberTypewiseSectionConfigGridFilter extends IFilterModel {
  memberTypeID: string | number | null;
}

export interface IMemberTypewiseSectionConfigGridPostModel
  extends IGridPostModel {
  filter?: IMemberTypewiseSectionConfigGridFilter;
}
